module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/kafka.07140ef8.svg";